export default "/images/ic-lang-card.svg?2c1edbc3aa90b12f46ef94c61feaf4e8";